import { Component, Input, inject } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CollapseComponent, DividerComponent, EmptyStateComponent } from '@tecalisdev/infinity';
import { OperationDetailOperationMetaComponent } from '../../../../../shared/components/operations/common/operation-detail-operation-meta/operation-detail-operation-meta.component';
import { OperationPolDetailsTriedDataComponent } from '../../../../../shared/components/operations/pol/operation-pol-details-tried-data/operation-pol-details-tried-data.component';
import { IOperationDetailResponse, OPERATION_STATUS } from '../../../../models/operations.models';
import { OperationDetailTabsDetailsMediaComponent } from '../operation-detail-tabs-details-media/operation-detail-tabs-details-media.component';
import { IOperationPolDetail, isAutoPolTry } from '../../../../../processes/models/processes.models';
import { OperationsHelperService } from '../../../../services/operations-helper.service';
import { NOT_AVAILABLE_DISPLAY } from '../../../../../core/utils/utils';

type PolDetailsCollapseSection = 'data' | 'media' | 'operation';

@Component({
	selector: 'app-operation-detail-tabs-details-pol',
	imports: [
		TranslatePipe,
		CollapseComponent,
		EmptyStateComponent,
		OperationPolDetailsTriedDataComponent,
		DividerComponent,
		OperationDetailOperationMetaComponent,
		OperationDetailTabsDetailsMediaComponent,
	],
	templateUrl: './operation-detail-tabs-details-pol.component.html',
	styleUrl: './operation-detail-tabs-details-pol.component.scss',
})
export class OperationDetailTabsDetailsPolComponent {
	@Input() detail: IOperationDetailResponse;

	private trans = inject(TranslateService);
	private operationsHelper = inject(OperationsHelperService);

	public readonly isAutoPolTry = isAutoPolTry;

	public OPERATION_STATUS = OPERATION_STATUS;
	public expandedCollapseSection: PolDetailsCollapseSection | null = 'data';

	public toggleCollapse(section: PolDetailsCollapseSection, expanded?: boolean): void {
		this.expandedCollapseSection = !expanded ? null : section;
	}

	public get polData(): IOperationPolDetail | null {
		return this.detail?.data ? (this.detail.data as unknown as IOperationPolDetail) : null;
	}

	public polTriesLabel(): string {
		return this.operationsHelper.getPolTriesCountLabel(this.polData);
	}

	public polCaptureMethodLabel(): string {
		const key =
			this.polData?.mode === 'auto'
				? 'WORKFLOWS.FORM.OPERATIONS.POL_MODE_ACTIVE'
				: 'WORKFLOWS.FORM.OPERATIONS.POL_MODE_STATIC';
		return this.trans.instant(key);
	}

	public polTypeLabel(): string {
		const type = this.polData?.type;
		if (!type) return NOT_AVAILABLE_DISPLAY;
		return this.trans.instant('MASTER.POL_TYPE.' + type.toUpperCase());
	}

	public polVerificationLabel(): string {
		const key =
			this.polData?.validation === 'auto'
				? 'PROCESSES.DETAIL.AUTOMATIC'
				: 'PROCESSES.DETAIL.MANUAL';
		return this.trans.instant(key);
	}
}
